// 🎓 LecturePage Markdown Loading Logic
import { lacksCourseAccess } from '../template/courseOwnershipState';
import { useState, useEffect } from 'react';
import { CourseDetail, GetLectureDetail200 } from '@edusense/course-client';

export const useMarkdownContent = (
  courseData: CourseDetail | undefined,
  lectureDetail: GetLectureDetail200 | undefined
) => {
  const [rawMarkdownContent, setRawMarkdownContent] = useState<string | null>(null);
  const [isMarkdownLoading, setIsMarkdownLoading] = useState<boolean>(false);
  const [markdownError, setMarkdownError] = useState<Error | null>(null);

  // --- Effect for setting markdown content ---
  useEffect(() => {
    // lectureDetail 로드 전이면 실행 중지
    if (!lectureDetail) {
      setRawMarkdownContent(null);
      setMarkdownError(null);
      setIsMarkdownLoading(false);
      return;
    }

    // 수강하지 않았고 공개 강의도 아닐 때만 차단
    if (lacksCourseAccess(courseData?.summary)) {
      setRawMarkdownContent(null);
      setMarkdownError(null);
      setIsMarkdownLoading(false);
      return;
    }

    // API response already contains markdown content in 'content' field
    // No need for separate fetch - use the content directly
    setIsMarkdownLoading(false);
    setMarkdownError(null);

    // content가 null이나 undefined가 아니면 빈 문자열이라도 유효한 콘텐츠로 처리
    if (lectureDetail.content !== null && lectureDetail.content !== undefined) {
      setRawMarkdownContent(lectureDetail.content);
      console.log("📝 Markdown content loaded from API response:", {
        contentLength: lectureDetail.content.length,
        preview: lectureDetail.content.substring(0, 100),
        isEmpty: lectureDetail.content === ""
      });
    } else {
      setRawMarkdownContent(null);
      console.log("⚠️ No markdown content in lecture detail");
    }
  }, [lectureDetail, courseData]);

  return {
    rawMarkdownContent,
    isMarkdownLoading,
    markdownError
  };
};
